import React, { useEffect, useState } from "react";
import {
  Container,
  Contact,
  Actions,
  Files,
  Resume,
  ViewInput,
} from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import { MdDelete, MdDownload, MdUpload } from "react-icons/md";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { useAuth } from "../../../hooks/AuthContext";
import Status from "../../../components/status";
import { format, isToday } from "date-fns";
import { Message } from "../../../GlobalStyles";
import { Button, Input, Modal, Spin, Tooltip } from "antd";

function getDeadlineBadge(deliveryDateStr, status, updateAtStr) {
  if (!deliveryDateStr) return null;

  const [delYear, delMonth, delDay] = deliveryDateStr.split("T")[0].split("-").map(Number);
  const deadlineDate = new Date(delYear, delMonth - 1, delDay);
  deadlineDate.setHours(0, 0, 0, 0);
  const formattedDelDate = `${String(delDay).padStart(2, "0")}/${String(delMonth).padStart(2, "0")}/${delYear}`;

  const isFinalized = status === "finalizado" || status === "assinado";
  let styles = {
    background: "#f5f5f5",
    border: "1px solid #d9d9d9",
    color: "#595959",
    label: "No prazo",
    isFinalized: false,
    text: "",
  };

  if (isFinalized) {
    const compDateStr = updateAtStr || new Date().toISOString();
    const [compYear, compMonth, compDay] = compDateStr.split("T")[0].split("-").map(Number);
    const completionDate = new Date(compYear, compMonth - 1, compDay);
    completionDate.setHours(0, 0, 0, 0);

    const formattedCompDate = `${String(compDay).padStart(2, "0")}/${String(compMonth).padStart(2, "0")}/${compYear}`;

    if (completionDate > deadlineDate) {
      styles = {
        background: "#fffbe6",
        border: "1px solid #ffe58f",
        color: "#d4b106",
        label: "Entregue com atraso",
        isFinalized: true,
        text: formattedCompDate,
      };
    } else {
      styles = {
        background: "#f5f5f5",
        border: "1px solid #d9d9d9",
        color: "#595959",
        label: "Entregue no prazo",
        isFinalized: true,
        text: formattedCompDate,
      };
    }
  } else {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const diffTime = deadlineDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    styles.text = formattedDelDate;

    if (diffDays < 0) {
      styles = {
        background: "#fff2f0",
        border: "1px solid #ffccc7",
        color: "#ff4d4f",
        label: "Atrasado",
        isFinalized: false,
        text: formattedDelDate,
      };
    } else if (diffDays === 0) {
      styles = {
        background: "#fffbe6",
        border: "1px solid #ffe58f",
        color: "#d4b106",
        label: "Vence hoje",
        isFinalized: false,
        text: formattedDelDate,
      };
    }
  }

  return styles.isFinalized ? (
    <Tooltip title={`Prazo estimado: ${formattedDelDate}`}>
      <span
        style={{
          background: styles.background,
          border: styles.border,
          color: styles.color,
          padding: "4px 12px",
          borderRadius: "50px",
          fontSize: "12px",
          fontWeight: "600",
          display: "inline-flex",
          alignItems: "center",
          height: "28px",
          cursor: "pointer",
        }}
      >
        Data de entrega: {styles.text}
      </span>
    </Tooltip>
  ) : (
    <span
      style={{
        background: styles.background,
        border: styles.border,
        color: styles.color,
        padding: "4px 12px",
        borderRadius: "50px",
        fontSize: "12px",
        fontWeight: "600",
        display: "inline-flex",
        alignItems: "center",
        height: "28px",
      }}
    >
      Prazo: {styles.text} ({styles.label})
    </span>
  );
}

export default function OSDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState({
    items: [],
  });
  const [files, setFiles] = useState([]);
  const [filesUp, setFilesUp] = useState([]);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState("");
  const [error, setError] = useState("");
  const [observation, setObservation] = useState("");
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleModalEdit, setVisibleModalEdit] = useState(false);
  const [visibleModalMessage, setVisibleModalMessage] = useState(false);

  useEffect(() => {
    loadingOS();
  }, [id]);

  async function loadingOS() {
    await api
      .get(`/order/${id}`)
      .then((response) => {
        let totalS = 0;
        let totalV = 0;
        response.data.items.map((item) => {
          totalS += item.amount;
          totalV += item.amount * item.value;
        });
        setFiles(response.data.docs);
        setOrder(response.data);
        let message = response.data.messages.pop();
        if (message) {
          response.data.messages.push(message);
          if (message.type != "tecnico") {
            setVisibleModalMessage(true);
          }
        }
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function uploadDocs(filesUpload) {
    filesUpload.map(async (item) => {
      const data = new FormData();
      data.append("type", user.type);
      data.append("file", item, item.name);
      await api
        .post(`/doc/${order.id}`, data)
        .then(async (response) => {
          setFilesUp((prevFiles) => {
            const newState = [...prevFiles];
            newState.shift();
            return newState;
          });
          setFiles((prevFiles) => [...prevFiles, response.data]);
          toast.success(`O documento ${item.name} foi enviado com sucesso`);
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        });
    });
  }

  async function editOrder() {
    setIsLoadingModal(true);
    await api
      .put(`/order/${id}`, {
        observation: observation,
      })
      .then((response) => {
        setOrder(response.data);
        setVisibleModalEdit(false);
        toast.success("OS editada com sucesso");
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingModal(false);
  }

  async function deleteDoc(fileDelete) {
    await api
      .delete(`/doc/${fileDelete.id}?type=${user.type}`)
      .then(async (response) => {
        setFiles((prevFiles) => {
          const newFiles = [...prevFiles];
          const idx = newFiles.indexOf(fileDelete);
          if (idx > -1) {
            newFiles.splice(idx, 1);
          }
          return newFiles;
        });
        toast.success(
          `O documento ${String(fileDelete.file).substr(
            33
          )} foi deletado com sucesso`
        );
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function handleSubmitModal() {
    if (!message || !message.trim()) return;
    setIsLoading("modal");
    if (order.status === "aberto") {
      await api
        .put(`/recused-order/${order.id}`, { message: message })
        .then((response) => {
          toast.success("Ordem de Serviço recusada com sucesso");
          setVisibleModal(false);
          loadingOS();
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error("Erro Interno. verifique sua conexão e tente novamente");
          }
        });
    } else {
      await api
        .put(`/status/${order.id}`, {
          status: "pendente",
          message: message,
        })
        .then((response) => {
          toast.success("Solicitação de documentos efetuada com sucesso");
          setVisibleModal(false);
          loadingOS();
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error("Erro Interno. verifique sua conexão e tente novamente");
          }
        });
    }
    setIsLoading("");
  }

  return (
    <Container>
      {loading ? (
        <Spin style={{ marginTop: 50 }} />
      ) : (
        <>
          {error ? (
            <Message>{error}</Message>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <h1 style={{ marginRight: 0, marginBottom: 0 }}>Ordem de Serviço #{id}</h1>
                <Status status={order.status} />
                {order.urgent && (
                  <Status isUrgent={true} style={{ marginLeft: 0 }} />
                )}
                {order.type && (
                  <span
                    style={{
                      background: order.type === "elaboracao" ? "#2db7f5" : "#87d068",
                      color: "#fff",
                      padding: "4px 12px",
                      borderRadius: "50px",
                      fontSize: "12px",
                      fontWeight: "600",
                      display: "inline-flex",
                      alignItems: "center",
                      height: "28px",
                    }}
                  >
                    {order.type === "elaboracao" ? "Elaboração" : "Renovação"}
                  </span>
                )}
                  {getDeadlineBadge(order.delivery_date, order.status, order.update_at)}
              </div>
              <p style={{ fontSize: 12, margin: "5px 0" }}>
                Aberta em{" "}
                {format(new Date(order.create_at), "dd/MM/yyyy HH:mm")}
              </p>
              {order.user && (
                <>
                  <h3 style={{ marginTop: 25 }}>Franqueado</h3>
                  <Contact>
                    <img
                      src={
                        order.user.photo
                          ? order.user.photo_url
                          : "https://png.pngtree.com/png-vector/20190710/ourlarge/pngtree-user-vector-avatar-png-image_1541962.jpg"
                      }
                    />
                    <div>
                      <p>{order.user.name}</p>
                    </div>
                  </Contact>
                </>
              )}
              {!!order.order_linked_id && (
                <>
                  <h3>
                    {!order.order_doc_recused
                      ? "Visualizar OS de revisão"
                      : "Visualizar OS que foi solicitada a revisão"}
                  </h3>
                  <Button
                    type="primary"
                    onClick={() => {
                      navigate(`/tecnico/os/${order.order_linked_id}`);
                    }}
                    style={{
                      marginBottom: 15,
                      height: 40,
                      width: "fit-content",
                      borderRadius: 50,
                      fontWeight: 600,
                    }}
                  >{`Visualizar OS: ${order.order_linked_id}`}</Button>
                </>
              )}
              {order.company_id && (
                <>
                  <h3>Formulário da Empresa</h3>
                  <Button
                    type="primary"
                    onClick={() => {
                      navigate(`/tecnico/view-company/${order.company_id}`);
                    }}
                    style={{
                      marginBottom: 15,
                      height: 40,
                      width: "fit-content",
                      borderRadius: 50,
                      fontWeight: 600,
                    }}
                  >
                    Visualizar
                  </Button>
                </>
              )}

              <h3>Documentos do Franqueado</h3>
              <Files>
                {!files.find((item) => item.type == "cliente") && (
                  <Message style={{ width: "auto", fontSize: 14 }}>
                    Nenhum documento enviado até o momento
                  </Message>
                )}
                {files.map((item) => {
                  if (item.type == "cliente") {
                    return (
                      <div key={item.file}>
                        <p>{String(item.file).substr(33)}</p>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            minHeight: 20,
                            padding: 0,
                            margin: 0,
                          }}
                        >
                          <MdDownload
                            onClick={() => {
                              window.open(
                                "https://guruseg-data.s3.sa-east-1.amazonaws.com/" +
                                  item.file
                              );
                            }}
                            style={{ cursor: "pointer", marginLeft: 10 }}
                            size={22}
                            color="#000"
                          />
                          <MdDelete
                            onClick={() => {
                              deleteDoc(item);
                            }}
                            style={{ cursor: "pointer", marginLeft: 10 }}
                            size={22}
                            color="#000"
                          />
                        </div>
                      </div>
                    );
                  }
                })}
              </Files>
              <h3>Documentos do Técnico</h3>
              <Files>
                <div
                  className="button"
                  for="avatar"
                  style={{ position: "relative" }}
                >
                  <p style={{ color: "#fff", fontSize: 16, margin: "0 10px" }}>
                    Upload
                  </p>
                  <MdUpload size={22} color="#fff" style={{ marginLeft: 15 }} />
                  <input
                    id="avatar"
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      opacity: 0,
                    }}
                    multiple
                    type="file"
                    accept="image/"
                    onChange={(file) => {
                      let filesUp = Object.values(file.target.files);
                      filesUp.map((item) => {
                        item.file_url = URL.createObjectURL(item);
                      });
                      setFilesUp((prevFiles) => [...prevFiles, ...filesUp]);
                      uploadDocs(filesUp);
                    }}
                  />
                </div>
                {files.map((item) => {
                  if (item.type == "tecnico") {
                    return (
                      <div key={item.file}>
                        <p>{String(item.file).substr(33)}</p>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            minHeight: 20,
                            padding: 0,
                            margin: 0,
                          }}
                        >
                          <MdDownload
                            onClick={() => {
                              window.open(
                                "https://guruseg-data.s3.sa-east-1.amazonaws.com/" +
                                  item.file
                              );
                            }}
                            style={{ cursor: "pointer", marginLeft: 10 }}
                            size={22}
                            color="#000"
                          />
                          <MdDelete
                            onClick={() => {
                              deleteDoc(item);
                            }}
                            style={{ cursor: "pointer", marginLeft: 10 }}
                            size={22}
                            color="#000"
                          />
                        </div>
                      </div>
                    );
                  }
                })}
                {filesUp.map((item) => {
                  return (
                    <div key={item.name}>
                      <p>{item.name}</p>
                      <Spin size="small" style={{ margin: "0 0 0 5px" }} />
                    </div>
                  );
                })}
              </Files>
              {!!order.collaborators && (
                <>
                  <h3 style={{ marginBottom: 5 }}>Funcionários</h3>
                  <p style={{ marginBottom: 15 }}>{order.collaborators}</p>
                </>
              )}
              {order.observation && (
                <>
                  <h3 style={{ marginBottom: 5 }}>Observação do Franqueado</h3>
                  <p style={{ marginBottom: 15 }}>{order.observation}</p>
                </>
              )}
              {order.observationCollaborator && (
                <>
                  <h3 style={{ marginBottom: 5 }}>Observação do Técnico</h3>
                  <p style={{ marginBottom: 15 }}>
                    {order.observationCollaborator}
                  </p>
                </>
              )}
              <h3 style={{ marginBottom: 5 }}>Setor</h3>
              <p style={{ marginBottom: 15 }}>{order.sector}</p>
              <div
                className="service"
                style={{ border: "none", padding: "0 25px" }}
              >
                <p style={{ flex: 1 }}>Serviço</p>
                <p>Quantidade</p>
              </div>
              <Resume>
                <div>
                  {order?.items?.map((item) => {
                    return (
                      <div className="service">
                        <p style={{ flex: 1 }}>{item.name}</p>
                        <p>{item.amount}x</p>
                      </div>
                    );
                  })}
                </div>
              </Resume>
              <Actions>
                {(order.status == "andamento" ||
                  order.status == "alteracao") && (
                  <Button
                    type="primary"
                    onClick={async () => {
                      setMessage("");
                      setVisibleModal(true);
                    }}
                  >
                    Solicitar Documentos
                  </Button>
                )}
                {(order.status == "andamento" ||
                  order.status == "alteracao") && (
                  <Button
                    type="primary"
                    loading={isLoading == "finalizar"}
                    onClick={async () => {
                      Modal.confirm({
                        title: "Confirmar finalização da OS",
                        content: "Tem certeza que deseja finalizar esta OS?",
                        okText: "Sim, finalizar",
                        cancelText: "Não",
                        onOk: async () => {
                          setIsLoading("finalizar");
                          let filesIdx = 0;
                          files.map((item) => {
                            if (item.type == "tecnico") {
                              filesIdx++;
                            }
                          });
                          if (filesIdx > 0) {
                            await api
                              .put(`/status/${order.id}`, { status: "finalizado" })
                              .then((response) => {
                                toast.success(
                                  "Ordem de Serviço aguardando aprovação do franqueado"
                                );
                                loadingOS();
                              })
                              .catch(({ response }) => {
                                if (response) {
                                  if (response.data) {
                                    if (response.data.message) {
                                      toast.warn(response.data.message);
                                    } else {
                                      toast.error(
                                        "Erro Interno. verifique sua conexão e tente novamente"
                                      );
                                    }
                                  } else {
                                    toast.error(
                                      "Erro Interno. verifique sua conexão e tente novamente"
                                    );
                                  }
                                } else {
                                  toast.error(
                                    "Erro Interno. verifique sua conexão e tente novamente"
                                  );
                                }
                              });
                          } else {
                            toast.error(
                              "Envie pelo menos um documento de resposta para finalizar a solicitação"
                            );
                          }
                          setIsLoading("");
                        },
                      });
                    }}
                  >
                    Finalizar OS
                  </Button>
                )}

                {!!order.messages.length && (
                  <Button
                    type="primary"
                    onClick={async () => {
                      setVisibleModalMessage(true);
                    }}
                  >
                    Ver Mensagens
                  </Button>
                )}
                {order.status == "aberto" && (
                  <Button
                    type="primary"
                    loading={isLoading == "accept"}
                    onClick={async () => {
                      setIsLoading("accept");
                      await api
                        .put(`/accept-order/${order.id}`)
                        .then((response) => {
                          toast.success("Ordem de Serviço aceita com sucesso");
                          loadingOS();
                        })
                        .catch(({ response }) => {
                          if (response) {
                            if (response.data) {
                              if (response.data.message) {
                                toast.warn(response.data.message);
                              } else {
                                toast.error(
                                  "Erro Interno. verifique sua conexão e tente novamente"
                                );
                              }
                            } else {
                              toast.error(
                                "Erro Interno. verifique sua conexão e tente novamente"
                              );
                            }
                          } else {
                            toast.error(
                              "Erro Interno. verifique sua conexão e tente novamente"
                            );
                          }
                        });
                      setIsLoading("");
                    }}
                  >
                    Aceitar OS
                  </Button>
                )}

                {order.status == "aberto" && (
                  <Button
                    type="primary"
                    onClick={async () => {
                      setMessage("");
                      setVisibleModal(true);
                    }}
                  >
                    Recusar OS
                  </Button>
                )}
                <Button
                  type="primary"
                  onClick={async () => {
                    setObservation(order.observationCollaborator);
                    setVisibleModalEdit(true);
                  }}
                >
                  Editar OS
                </Button>
              </Actions>
            </>
          )}
        </>
      )}

      <Modal
        title="Mensagens"
        width={500}
        open={visibleModalMessage}
        okText={"FECHAR"}
        cancelButtonProps={{
          style: {
            display: "none",
          },
        }}
        onCancel={() => {
          setVisibleModalMessage(false);
        }}
        onOk={() => {
          setVisibleModalMessage(false);
        }}
      >
        <div
          className="chat-window-body"
          style={{
            display: "flex",
            padding: 16,
            margin: "15px 0",
            height: "55vh",
            overflowY: "auto",
            flexDirection: "column-reverse",
          }}
        >
          {order?.messages?.map((msg, index) => {
            const messageClasses = [
              "message",
              msg.type === user.type ? "sent" : "received",
            ].join(" ");

            return (
              <div key={msg.id || index} className={messageClasses}>
                <div className={`message-content`}>
                  <p>{msg.message}</p>
                </div>
                <div
                  className="message-header"
                  style={{
                    display: "flex",
                    justifyContent:
                      msg.type === user.type ? "flex-end" : "flex-start",
                    gap: "8px",
                  }}
                >
                  <span
                    className="time-label"
                    style={{
                      fontSize: "0.7rem",
                      margin: "5px 0",
                      color: "#888",
                    }}
                  >
                    {format(
                      new Date(msg.create_at),
                      isToday(new Date(msg.create_at))
                        ? "HH:mm"
                        : "dd/MM/yyyy HH:mm"
                    )}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </Modal>
      <Modal
        open={visibleModal}
        onCancel={() => {
          setVisibleModal(false);
        }}
        onOk={handleSubmitModal}
        confirmLoading={isLoading === "modal"}
        okButtonProps={{ disabled: !message || !message.trim() }}
        title={order.status === "aberto" ? "Recusar OS" : "Solicitar Documentos"}
        okText={order.status === "aberto" ? "RECUSAR" : "SOLICITAR"}
        cancelText="FECHAR"
      >
        <div
          style={{
            margin: "15px 0",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <ViewInput style={{ marginRight: 0 }}>
            <p>Mensagem para o franqueado</p>
            <Input.TextArea
              rows={4}
              value={message}
              placeholder={
                order.status === "aberto"
                  ? "descreva o motivo da recusa"
                  : "descreva o que precisa para o franqueado"
              }
              onChange={(e) => {
                setMessage(e.target.value);
              }}
            />
          </ViewInput>
        </div>
      </Modal>

      <Modal
        open={visibleModalEdit}
        onCancel={() => {
          setVisibleModalEdit(false);
        }}
        onOk={() => {
          editOrder();
        }}
        loading={isLoadingModal}
        title="Editar OS"
        okText="SALVAR"
        cancelText="FECHAR"
      >
        <div
          style={{
            margin: "10px 0",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <ViewInput style={{ marginRight: 0 }}>
            <p>Observação</p>
            <Input.TextArea
              type="text"
              value={observation}
              placeholder="deixe aqui uma observação para o técnico."
              onChange={(text) => {
                setObservation(text.target.value);
              }}
            />
          </ViewInput>
        </div>
      </Modal>
    </Container>
  );
}
